import React from "react";
import { CategoryCardProps } from "./CategoryCard.types";
import { CategoryImage } from "./CategoryCard.styles";
import { Body5MediumTypography } from "../../../primitives/Typography/typographyVariants";
import FlexColumn from "../../../components/Layout/FlexColumn/FlexColumn";

export const CategoryCard: React.FC<CategoryCardProps> = ({
  category,
  onClick,
  dataCy,
  imageUrl,
  fallbackImageUrl,
  imageHeight = "84px",
  imageWidth = "76px",
  cardHeight = "76px",
  cardWidth = "92px",
  cardBorderRadius = "16px",
  cardBorderColor = "border.wishlink.default",
  cardBackgroundColor = "background.wishlink.secondary",
}) => {
  const displayName = category?.display_name || category?.name || "";

  return (
    <FlexColumn
      onClick={onClick}
      data-cy={dataCy}
      gap={8}
      alignItems="center"
      cursor="pointer"
      width={cardWidth}
    >
      <FlexColumn
        backgroundColor={cardBackgroundColor}
        border="1px solid"
        borderRadius={cardBorderRadius}
        borderColor={cardBorderColor}
        position="relative"
        width={cardWidth}
        height={cardHeight}
        alignItems="center"
        flexShrink={0}
      >
        {imageUrl && (
          <CategoryImage
            src={imageUrl}
            alt={displayName}
            placeholder={fallbackImageUrl}
            width={imageWidth}
            height={imageHeight}
          />
        )}
      </FlexColumn>
      <Body5MediumTypography color="text.default.default" textAlign="center">
        {displayName}
      </Body5MediumTypography>
    </FlexColumn>
  );
};
